import type { FunctionComponent } from "react";
import AddBudgetInternalModalAdminPartial from "../../../../partials/admin/menus/campaign/add-budget-internal-modal.admin";

export const AddBudgetInternalModalAdminScreen: FunctionComponent = () => {
  return <AddBudgetInternalModalAdminPartial />;
};
